import { render, staticRenderFns } from "./wyDisputeType.vue?vue&type=template&id=7c725d32&scoped=true&"
import script from "./wyDisputeType.vue?vue&type=script&lang=js&"
export * from "./wyDisputeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c725d32",
  null
  
)

export default component.exports